// src/api/api.js
import axios from 'axios';

console.log("process.env.REACT_APP_API_URL", process.env.REACT_APP_API_URL);

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true // Important for sending cookies
});

// Add request interceptor to include the access token
api.interceptors.request.use(
    (config) => {
        const token = document.cookie
            .split('; ')
            .find(row => row.startsWith('accessToken='))
            ?.split('=')[1];

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Add response interceptor for token refresh
api.interceptors.response.use(
    (response) => response, // Pass successful responses through
    async (error) => {
        const originalRequest = error.config;

        // Check if the error is due to an expired token
        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true; // Mark the request as retried to prevent loops

            try {
                // Attempt to refresh the token
                const refreshResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
                    {},
                    { withCredentials: true }
                );

                // Retry the original request with the new token
                const newToken = refreshResponse.data.accessToken;
                document.cookie = `accessToken=${newToken}; path=/;`;
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);

                // Clear cookies and let the app handle the redirect
                document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

                // Reject the original request
                return Promise.reject(refreshError);
            }
        }

        // Reject all other errors
        return Promise.reject(error);
    }
);

export default api;


// // src/api/api.js
// import axios from 'axios';
//
// console.log("process.env.REACT_APP_API_URL", process.env.REACT_APP_API_URL);
//
// const api = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     withCredentials: true // Important for sending cookies
// });
//
// // Add request interceptor to add authorization header
// api.interceptors.request.use(
//     (config) => {
//         const token = document.cookie
//             .split('; ')
//             .find(row => row.startsWith('accessToken='))
//             ?.split('=')[1];
//
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );
//
// // Add response interceptor for token refresh
// api.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;
//
//         // Add this condition to prevent infinite loops
//         if (error.response.status === 401 && !originalRequest._retry) {
//             originalRequest._retry = true;
//
//             try {
//                 // Try to refresh the token
//                 await axios.post(`${process.env.REACT_APP_API_URL}/auth/refresh-token`, {}, {
//                     withCredentials: true
//                 });
//
//                 // Retry the original request
//                 return api(originalRequest);
//             } catch (refreshError) {
//                 // If refresh fails, clear any stored tokens/user data
//                 document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
//                 document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
//
//                 // Redirect to login and prevent further retries
//                 window.location.href = '/login';
//                 return Promise.reject(refreshError);
//             }
//         }
//
//         // Add this to handle all other errors without retrying
//         return Promise.reject(error);
//     }
// );
//
// export default api;